<template>
    <div>
        <modal class="view-house" :class="{'has-record': viewHouseDetail.length}"  :display="modalStatus.viewHouse" @modalStatus="closeModal" >
            <h1>看屋明細</h1>
            <div class="wrap" >
                <div class="tasker" >
                    <img src="@/assets/img/icon/user_shot_black.svg" alt="">
                    受託人：{{tasker}}
                </div>
                <div v-if="viewHouseDetail.length == 0" class="is-empty">
                    <img src="@/assets/img/pages/task/looking_house.svg" alt="" srcset="">
                    尚無看房紀錄
                </div>
                <ul v-if="viewHouseDetail.length" >
                    <li v-for="(detail, index) in viewHouseDetail" :key="index">
                        <div class="phone">
                            <span class="sort">{{index+1}}.</span>
                            <span>電話：{{detail.visitorPhone}}</span>
                        </div>
                        <div class="date">
                            <span>時間：{{getFormatDate(detail.createTime)}}</span>
                        </div>
                    </li>
                </ul>
            </div>
        </modal>
    </div>
</template>
<script>
import Modal from '@/components/widge/Modal.vue';
import { mapGetters } from 'vuex'

import { 
    apiGetTaskDetail
    } from "@/apis/api.js"; 

export default {
    data () {
        return {
            componentKey: 0,
            viewHouseDetail: [],
        }
    },
    props:{
        task: null,
        tasker: null,
    },
    watch: {
        task: {
            handler: function (val) {
                // console.log(val)
                if(val){
                    this.getViewHouseDetail(val)
                }
            },
            immediate: true
        },
        modalStatus: function (val) {
            if(val.viewHouse){
                this.$store.commit('modalStatus/set_modal_mode', true)
            }else{
                this.$store.commit('modalStatus/set_modal_mode', false)
            }
        },
    },
    methods: {
        closeModal: function (type) {
            this.$store.dispatch('setModalStatus', {state: false, type: 'viewHouse'})
            this.$store.commit('modalStatus/set_modal_mode', false)
            this.componentKey += 1
        },
        getViewHouseDetail: function (taskId) {
            let data = taskId

            apiGetTaskDetail(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    this.viewHouseDetail = res.data.result.houseTaskDetailList
                }
            })
            .catch(err => {
                console.log(err)
            })
        },
        getFormatDate: function (time){
            var formatDate = [];
            var date = new Date(time);
            //一般日期 年 月 天 時 分
            formatDate[0] = date.getFullYear();
            formatDate[1] = date.getMonth()+1;
            formatDate[2] = date.getDate();
            formatDate[3] = (Array(2).join(0)+date.getHours(-8)).slice(-2);
            formatDate[4] = (Array(2).join(0)+date.getMinutes()).slice(-2);
            formatDate[5] = (Array(2).join(0)+date.getSeconds()).slice(-2);
            //月及天兩位數
            formatDate[6] = (Array(2).join(0)+formatDate[1]).slice(-2);
            formatDate[7] = (Array(2).join(0)+formatDate[2]).slice(-2);
            // console.log(formatDate[3] )
            //換算時區 台灣-8
            // if(formatDate[3] - 8 < 0){
            //     formatDate[3] = 24+(formatDate[3]-8);
            //     formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
            // }else{
            //     formatDate[3] = formatDate[3]-8;
            //     formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
            // }
            return formatDate[0]+'-'+formatDate[6]+'-'+formatDate[7];
        },
        // toCurrency: function (num){
        //     if(num){
        //         var parts = num.toString().split('.');
        //         // console.log(parts);
        //         parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        //         return parts.join('.');
        //     }
        // },
    },
    computed: {
        ...mapGetters({
            modalStatus: 'GET_MODAL_STATUS',
        })
    },
    components: {
        Modal,
    }
}
</script>
<style lang="scss"  >
    #modal.view-house{
        &.has-record{
            .modal-content{
                .detail{
                    .wrap{
                        ul{
                            &::-webkit-scrollbar {
                                display: none;
                            }
                            height: 400px;
                        }
                    }
                }
            }
        }
        .modal-content{
            width: 384px;
            padding: 32px !important;
            .detail{
                align-items: flex-start !important;
                >h1{
                    margin: 0 auto 32px auto;
                    text-align: center;
                }
                .wrap{
                    .is-empty{
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        padding: 65px 0 33px;
                        img{
                            margin-bottom: 12px;
                        }
                    }
                    .tasker{
                        display: flex;
                        align-items: center;
                        font-weight: 500;
                        padding-bottom: 20px;
                        border-bottom: 1px solid #f3f3f3;
                        width: 384px;
                        img{
                            margin-right: 8px;
                        }
                    }
                    ul{
                        overflow-x: hidden;
                        li{
                            width: 384px;
                            display: flex;
                            align-items: center;
                            padding: 16px 0;
                            border-bottom: 1px solid #f1f5f4 ;
                            .phone{
                                width: 167px;
                                margin-right: 40px;
                                .sort{
                                    margin-right: 12px;
                                }
                            }
                        }
                    }
                    ul::-webkit-scrollbar {
                        display: none;
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/widge/ViewHouseDetail.vue